module.exports = __webpack_public_path__ + "img/Cointelegraph.391d377e.png";